import { AxTabbedBase } from '@theme/ax-tabbed-base';

/**
 * Ax Variant Multi Slider — tabbed product carousel where each card carries its
 * own flavor (variant) selector + add-to-cart.
 *
 * Tabs / Swiper / Section Rendering API / a11y all live in AxTabbedBase. Each
 * slide renders an <ax-variant-card> which manages its own variant selection.
 *
 * @extends {AxTabbedBase}
 */
class AxVariantMultiSliderComponent extends AxTabbedBase {
  static bemPrefix = 'ax-variant-multi-slider';
}

customElements.define('ax-variant-multi-slider-component', AxVariantMultiSliderComponent);
